import { FLAGS, useFlag } from '@iheartjane/feature-flags';
import { Navigate, Outlet } from 'react-router';
import type { RouteObject } from 'react-router';

import { RequirePremiumAccess } from '@jane/business-admin/components/premium/RequirePremiumAccess';

import { Premium } from '../features/premium/Premium';
import { PremiumAgeGate } from '../features/premium/PremiumAgeGate';
import { PremiumCloudflareIntegrations } from '../features/premium/PremiumCloudflareIntegrations';
import { PremiumColors } from '../features/premium/PremiumColors';
import { PremiumExternalScripts } from '../features/premium/PremiumExternalScripts';
import { PremiumFonts } from '../features/premium/PremiumFonts';
import { PremiumFooter } from '../features/premium/PremiumFooter';
import { PremiumFooterTemplate } from '../features/premium/PremiumFooterTemplate';
import { PremiumGoogleAddons } from '../features/premium/PremiumGoogleAddons';
import { PremiumLogo } from '../features/premium/PremiumLogo';
import { PremiumMainMenu } from '../features/premium/PremiumMainMenu';
import { PremiumMenuEditor } from '../features/premium/PremiumMenuEditor';
import { PremiumSeo } from '../features/premium/PremiumSeo';
import { PremiumSignInPrompt } from '../features/premium/PremiumSignInPrompt';
import { PremiumStores } from '../features/premium/PremiumStores';

const GatedFooterTemplateRoute = () => {
  const isAllowed = useFlag(FLAGS.obCustomizePremiumFooter);

  return !isAllowed ? <Navigate to="/premium" /> : <PremiumFooterTemplate />;
};

const GatedCloudflareRoute = () => {
  const isAllowed = useFlag(FLAGS.c2PremiumCloudflareIntegrations);

  return !isAllowed ? (
    <Navigate to="/premium" />
  ) : (
    <PremiumCloudflareIntegrations />
  );
};

export const premiumRoutes = (): RouteObject[] => [
  {
    path: '/premium',
    element: (
      <RequirePremiumAccess>
        <Outlet />
      </RequirePremiumAccess>
    ),
    children: [
      {
        index: true,
        element: <Premium />,
      },
      {
        path: ':menu_id/logo',
        element: <PremiumLogo />,
      },
      {
        path: ':menu_id/fonts',
        element: <PremiumFonts />,
      },
      {
        path: ':menu_id/footer',
        element: <PremiumFooter />,
      },
      {
        path: ':menu_id/footer-template',
        element: <GatedFooterTemplateRoute />,
      },
      {
        path: ':menu_id/main-menu',
        element: <PremiumMainMenu />,
      },
      {
        path: ':menu_id/sign-in-prompt',
        element: <PremiumSignInPrompt />,
      },
      {
        path: ':menu_id/age-gate',
        element: <PremiumAgeGate />,
      },
      {
        path: ':menu_id/colors',
        element: <PremiumColors />,
      },
      {
        path: ':menu_id/stores',
        element: <PremiumStores />,
      },
      {
        path: ':menu_id/cloudflare',
        element: <GatedCloudflareRoute />,
      },
      {
        path: ':menu_id/google',
        element: <PremiumGoogleAddons />,
      },
      {
        path: ':menu_id/seo',
        element: <PremiumSeo />,
      },
      {
        path: ':menu_id/external-scripts',
        element: <PremiumExternalScripts />,
      },
      {
        path: ':menu_id/menu-editor',
        element: <PremiumMenuEditor />,
      },
    ],
  },
];
